import { useQuery } from "@tanstack/react-query"
import { investmentOversightApi } from "../api/investmentOversight";
import { useFilterContext } from "../../../shared/context";
import { formatCurrency } from "../../../shared/utils";

export const useInvestmentOversight = () => {

    const { tempFilters, quickFilters, handleUpdateTempFilters, handleResetFilters, handleApplyFilters } = useFilterContext();

    const { data: benefitData, isLoading: benefitLoading, isFetching: benefitFetching, error: benefitError } = useQuery({
        queryKey: ["investment-oversight-benefit-delivery", quickFilters.workstream],
        queryFn: async () => {
            const params = {
                workstream_id: quickFilters.workstream || null,
            };
            const response = await investmentOversightApi.fetchBenefitDelivery(params);
            return response.data
        }
    });

    const { data: investmentData, isLoading: investmentLoading, isFetching: investmentFetching, error: investmentError } = useQuery({
        queryKey: ["investment-oversight-investment-performance", quickFilters.workstream],
        queryFn: async () => {
            const params = {
                workstream_id: quickFilters.workstream || null,
            };
            const response = await investmentOversightApi.fetchInvestmentPerformance(params);
            return response.data
        }
    });

    const { data: networkData, isLoading: networkLoading, isFetching: networkFetching, error: networkError } = useQuery({
        queryKey: ["investment-oversight-network-performance", quickFilters.workstream],
        queryFn: async () => {
            const params = {
                workstream_id: quickFilters.workstream || null,
            };
            const response = await investmentOversightApi.fetchNetworkPerformance(params);
            return response.data;
        },
    });

    return {

        benefitChartData: benefitData?.map((value: { programme: any; total_original_value: any; percent_delivered: any; }) => {
            return { programme: value.programme, value: value.total_original_value, delivered: value.percent_delivered, label: '48 sites / 22 sites' }
        }) || [],
        benefitTableData: benefitData?.map((value: { programme: any; planned_outputs: any; delivered_outputs: any; percent_delivered: any; benefits_realised: any; }) => {
            return {
                programme: value.programme,
                plannedOutputs: value.planned_outputs,
                delivered: value.delivered_outputs,
                percentDelivered: value.percent_delivered,
                monetisedBenefit: value.benefits_realised,
                riskReduction: '£54m',
            }
        }) || [],
        isBenefitLoading: benefitLoading || benefitFetching, benefitError,

        investmentTableData: investmentData?.map((value: { programme_name: any; planned: any; committed: any; raised: any; actual: any; variance_percent: number; }) => {
            return {
                programme: value.programme_name,
                planned: formatCurrency(value.planned),
                committed: formatCurrency(value.committed),
                raised: formatCurrency(value.raised),
                actual: formatCurrency(value.actual),
                variance: `${value.variance_percent}%`
            }
        }),
        investmentChartData: investmentData?.map((value: { programme_name: any; planned: number; committed: number; raised: number; actual: number; variance_pounds: number; ragRating: string; }) => {
            return {
                programme: value.programme_name,
                planned: value.planned,
                committed: value.committed,
                raised: value.raised,
                actual: value.actual,
                rag: value.ragRating.toLowerCase()
            }
        }),
        isInvestmentLoading: investmentLoading || investmentFetching, investmentError,

        networkData: networkData?.map((value: { region_name: any; budget_spend_percent: number; budget_spend_value: any; outputs_delivered_percent: number; outputs_delivered_value: any; total_spend_value: any; rag_indicator: "green" | "amber" | "red"; approved_budget: any; total_planned_budget: any; }) => {
            return { region: value.region_name, budgetSpend: `${value.budget_spend_percent}%`, budgetSpendValue: value.budget_spend_value, approvedBudget: value.approved_budget, outputsDelivered: `${value.outputs_delivered_percent}%`, outputsDeliveredValue: value.outputs_delivered_value, totalSpend: value.total_spend_value, totalSpendValue: value.total_spend_value, totalPlannedBudget: value.total_planned_budget, rag: value.rag_indicator.toLocaleLowerCase() };
        }) || [],
        isNetworkLoading: networkLoading || networkFetching, networkError,

        tempFilters, handleUpdateTempFilters, handleResetFilters, handleApplyFilters

    }

}